import { render, staticRenderFns } from "./MerchantCreate.vue?vue&type=template&id=96054ff0&"
import script from "./MerchantCreate.vue?vue&type=script&lang=js&"
export * from "./MerchantCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports